import { render, staticRenderFns } from "./AlbaranesList.vue?vue&type=template&id=3e08974a&scoped=true&lang=pug"
import script from "./AlbaranesList.vue?vue&type=script&lang=js"
export * from "./AlbaranesList.vue?vue&type=script&lang=js"
import style0 from "./AlbaranesList.vue?vue&type=style&index=0&id=3e08974a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e08974a",
  null
  
)

export default component.exports